/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadBillingsCsv200Response
 */
export interface UploadBillingsCsv200Response {
    /**
     * アップロード処理のトラッキングID
     * @type {string}
     * @memberof UploadBillingsCsv200Response
     */
    operationUploadId?: string;
    /**
     * アップロード日時
     * @type {Date}
     * @memberof UploadBillingsCsv200Response
     */
    uploadedAt?: Date;
    /**
     * アップロード総額
     * @type {number}
     * @memberof UploadBillingsCsv200Response
     */
    amount?: number;
    /**
     * アップロード成功した伝票数
     * @type {number}
     * @memberof UploadBillingsCsv200Response
     */
    successCount?: number;
    /**
     * 注文番号一覧
     * @type {Array<string>}
     * @memberof UploadBillingsCsv200Response
     */
    orderNos?: Array<string>;
}

/**
 * Check if a given object implements the UploadBillingsCsv200Response interface.
 */
export function instanceOfUploadBillingsCsv200Response(value: object): value is UploadBillingsCsv200Response {
    return true;
}

export function UploadBillingsCsv200ResponseFromJSON(json: any): UploadBillingsCsv200Response {
    return UploadBillingsCsv200ResponseFromJSONTyped(json, false);
}

export function UploadBillingsCsv200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBillingsCsv200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'operationUploadId': json['operation_upload_id'] == null ? undefined : json['operation_upload_id'],
        'uploadedAt': json['uploaded_at'] == null ? undefined : (new Date(json['uploaded_at'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'successCount': json['success_count'] == null ? undefined : json['success_count'],
        'orderNos': json['order_nos'] == null ? undefined : json['order_nos'],
    };
}

export function UploadBillingsCsv200ResponseToJSON(json: any): UploadBillingsCsv200Response {
    return UploadBillingsCsv200ResponseToJSONTyped(json, false);
}

export function UploadBillingsCsv200ResponseToJSONTyped(value?: UploadBillingsCsv200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_upload_id': value['operationUploadId'],
        'uploaded_at': value['uploadedAt'] == null ? undefined : ((value['uploadedAt']).toISOString()),
        'amount': value['amount'],
        'success_count': value['successCount'],
        'order_nos': value['orderNos'],
    };
}

